import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import FontAwesomeIcon from "../../components/FontAwesomeIcon";
import { faTrashCan } from "@fortawesome/pro-regular-svg-icons";

const DeleteIconButton = ({ onDelete, title = "Delete", icon }) => {
  return (
    <Tooltip title={title}>
      <IconButton onClick={onDelete} size="large">
        <FontAwesomeIcon variant="darker" icon={icon ?? faTrashCan} />
      </IconButton>
    </Tooltip>
  );
};

export default DeleteIconButton;
